"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

var _order = require("@/api/cms/order");

var _contract = require("@/api/cms/contract");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'OrderSection',
  props: {
    contractId: {
      type: [Number, String],
      default: null
    },
    contractNo: {
      type: String,
      default: ''
    },
    sourceContractNo: {
      type: String,
      default: ''
    },
    disableAutoLoad: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      coolHomePlanList: [],
      reviewList: [],
      auditList: [],
      specialApplyOptions: [],
      originalOrderOptions: [],
      coolHomeDialogVisible: false,
      coolHomeFrameUrl: '',
      selectedAuditIds: [],
      selectedSchemeIds: [],
      auditSelections: {},
      expandedRows: [],
      isAllExpanded: false,
      refreshLoading: false,
      syncLoading: false,
      orderLoading: false
    };
  },
  computed: {
    canBatchSetTryInstall: function canBatchSetTryInstall() {
      var selectedAudits = this.getSelectedAuditRows();
      return selectedAudits.length > 0 && selectedAudits.length === this.selectedAuditIds.length && selectedAudits.every(function (audit) {
        return audit.productionStatus === '未提交' && audit.isTryInstall !== null && audit.isTryInstall !== undefined && Number(audit.isTryInstall) === 0;
      });
    },
    canBatchCancelTryInstall: function canBatchCancelTryInstall() {
      var selectedAudits = this.getSelectedAuditRows();
      return selectedAudits.length > 0 && selectedAudits.length === this.selectedAuditIds.length && selectedAudits.every(function (audit) {
        return audit.productionStatus === '未提交' && Number(audit.isTryInstall) === 1;
      });
    },
    isAllChecked: function isAllChecked() {
      var editableSchemes = this.coolHomePlanList.filter(function (item) {
        return item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        });
      });
      return editableSchemes.length > 0 && editableSchemes.every(function (item) {
        return item._checked;
      });
    },
    isIndeterminate: function isIndeterminate() {
      var editableSchemes = this.coolHomePlanList.filter(function (item) {
        return item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        });
      });
      return editableSchemes.some(function (item) {
        return item._checked;
      }) && !editableSchemes.every(function (item) {
        return item._checked;
      });
    }
  },
  mounted: function mounted() {
    this.getOriginalOrderList();
  },
  watch: {
    contractId: {
      handler: function handler(val) {
        if (val) {
          if (this.disableAutoLoad) {
            // 禁用自动加载时，只加载原单号列表
            this.getOriginalOrderList();
          } else {
            this.loadData();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    getSelectedAuditRows: function getSelectedAuditRows() {
      var _this = this;

      return this.coolHomePlanList.reduce(function (selectedAudits, scheme) {
        return selectedAudits.concat((scheme.designSchemeAudits || []).filter(function (audit) {
          return _this.selectedAuditIds.includes(audit.rowId);
        }));
      }, []);
    },
    checkPer: function checkPer(perm) {
      try {
        return this.$parent.checkPer(['admin', perm]);
      } catch (_unused) {
        return true;
      }
    },
    parseSpecialApply: function parseSpecialApply(value) {
      if (!value) return [];

      try {
        return JSON.parse(value);
      } catch (e) {
        if (typeof value === 'string' && value.includes(',')) {
          return value.split(',').map(function (item) {
            return item.trim().replace(/^['"]|['"]$/g, '');
          });
        }

        return [];
      }
    },
    loadData: function loadData() {
      if (!this.contractId) return;
      this.getDesignSchemes();
      this.getKuJiaLeUrl();
      this.getSpecialApplyList();
      this.getOriginalOrderList();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      if (!this.contractId) return;
      this.refreshLoading = true;
      this.getDesignSchemes().finally(function () {
        _this2.refreshLoading = false;

        _this2.$message.success('刷新成功');
      });
    },
    toggleAllExpand: function toggleAllExpand() {
      if (this.isAllExpanded) {
        this.expandedRows = [];
      } else {
        this.expandedRows = this.coolHomePlanList.map(function (item) {
          return item.rowId;
        });
      }

      this.isAllExpanded = !this.isAllExpanded;
    },
    getKuJiaLeUrl: function () {
      var _getKuJiaLeUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, kuJiaLeFrameUrl, coolHomeDesignUrlTemplate, coolHomeDesignUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.contractId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return (0, _order.associationKuJiaLe)({
                  contractId: this.contractId
                });

              case 5:
                response = _context.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl;

                  if (typeof kuJiaLeFrameUrl === 'string') {
                    kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  }

                  coolHomeDesignUrlTemplate = this.$store.state.api.coolHomeDesignUrl;
                  coolHomeDesignUrl = coolHomeDesignUrlTemplate.replace('{kuJiaLeFrameUrl}', kuJiaLeFrameUrl).replace('{contractId}', this.contractId).replace('{userName}', response.data.userName);
                  this.coolHomeFrameUrl = coolHomeDesignUrl;
                }

                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function getKuJiaLeUrl() {
        return _getKuJiaLeUrl.apply(this, arguments);
      }

      return getKuJiaLeUrl;
    }(),
    handleDesign: function () {
      var _handleDesign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var response, kuJiaLeFrameUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (row.designScheme) {
                  _context2.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案编码');
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return (0, _order.getDesignSchemeUrl)({
                  designScheme: row.designScheme
                });

              case 6:
                response = _context2.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl;
                  if (typeof kuJiaLeFrameUrl === 'string') kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  window.open(kuJiaLeFrameUrl, '_blank');
                } else {
                  this.$message.error('获取设计方案地址失败');
                }

                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);
                this.$message.error('调用获取设计方案地址接口失败');

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));

      function handleDesign(_x) {
        return _handleDesign.apply(this, arguments);
      }

      return handleDesign;
    }(),
    handleRowCheckChange: function handleRowCheckChange(row) {
      var _this3 = this;

      var selectedIds = this.coolHomePlanList.filter(function (item) {
        return item._checked;
      }).map(function (item) {
        return item.rowId;
      });
      this.selectedSchemeIds = selectedIds;
      this.coolHomePlanList.forEach(function (scheme) {
        var isSelected = selectedIds.includes(scheme.rowId);

        if (scheme.designSchemeAudits && scheme.designSchemeAudits.length > 0) {
          if (isSelected) {
            scheme.designSchemeAudits.forEach(function (audit) {
              audit._checked = true;
            });
            _this3.auditSelections[scheme.rowId] = scheme.designSchemeAudits.map(function (a) {
              return a.rowId;
            });
          } else {
            scheme.designSchemeAudits.forEach(function (audit) {
              audit._checked = false;
            });
            _this3.auditSelections[scheme.rowId] = [];
          }
        }
      });
      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    handleSelectAll: function handleSelectAll(checked) {
      this.coolHomePlanList.forEach(function (item) {
        if (item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        })) {
          item._checked = checked;
        }
      });
      this.handleRowCheckChange({});
    },
    handleAuditSelectAll: function handleAuditSelectAll(checked, schemeRow) {
      if (schemeRow.designSchemeAudits) {
        var _editableAudits = schemeRow.designSchemeAudits.filter(function (audit) {
          return audit.productionStatus === '未提交' || audit.productionStatus === '回退';
        });

        _editableAudits.forEach(function (audit) {
          audit._checked = checked;
        });
      }

      var editableAudits = schemeRow.designSchemeAudits ? schemeRow.designSchemeAudits.filter(function (audit) {
        return audit.productionStatus === '未提交' || audit.productionStatus === '回退';
      }) : [];

      if (checked) {
        this.auditSelections[schemeRow.rowId] = editableAudits.map(function (a) {
          return a.rowId;
        });
      } else {
        this.auditSelections[schemeRow.rowId] = [];
      }

      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    handleSyncData: function () {
      var _handleSyncData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var data, response, isSuccess;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!row.id || !row.designScheme)) {
                  _context3.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案ID或编码');
                return _context3.abrupt("return");

              case 3:
                if (!this.syncLoading) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                this.syncLoading = true;
                _context3.prev = 6;
                data = {
                  designSchemeId: row.id,
                  designScheme: row.designScheme,
                  contractId: this.contractId || 0
                };
                _context3.next = 10;
                return (0, _order.saveKuJiaLeAuditList)(data);

              case 10:
                response = _context3.sent;
                isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                if (!isSuccess) {
                  _context3.next = 23;
                  break;
                }

                this.$message.success('同步数据成功');
                _context3.prev = 14;
                _context3.next = 17;
                return Promise.all([this.getDesignSchemes(), this.handleOperation(row)]);

              case 17:
                _context3.next = 21;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](14);

              case 21:
                _context3.next = 24;
                break;

              case 23:
                this.$message.error(response && response.msg || response && response.data && response.data.msg || '同步数据失败');

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t1 = _context3["catch"](6);
                this.$message.error(_context3.t1.message || '调用同步数据接口失败');

              case 29:
                _context3.prev = 29;
                this.syncLoading = false;
                return _context3.finish(29);

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 26, 29, 32], [14, 19]]);
      }));

      function handleSyncData(_x2) {
        return _handleSyncData.apply(this, arguments);
      }

      return handleSyncData;
    }(),
    handleOperation: function () {
      var _handleOperation = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var _this4 = this;

        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (row.id) {
                  _context4.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案ID');
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                _context4.next = 6;
                return (0, _order.getCmsCustDesignSchemeAuditList)({
                  designSchemeId: row.id
                });

              case 6:
                response = _context4.sent;

                if (response && (response.code === 200 || response.data)) {
                  this.auditList = (response.data || []).map(function (item) {
                    if (item.specialApplyName) {
                      var specialApplyNames = _this4.parseSpecialApply(item.specialApplyName);

                      if (Array.isArray(specialApplyNames)) {
                        item.specialApplication = specialApplyNames.map(function (id) {
                          var apply = _this4.specialApplyOptions.find(function (opt) {
                            return opt.id === parseInt(id);
                          });

                          return apply ? apply.title : id;
                        });
                      } else {
                        item.specialApplication = [];
                      }
                    } else {
                      item.specialApplication = [];
                    }

                    item.originalOrder = item.originalOrderNumber || '';
                    return item;
                  });
                }

                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);
                this.$message.error('调用查询提审单信息接口失败');

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));

      function handleOperation(_x3) {
        return _handleOperation.apply(this, arguments);
      }

      return handleOperation;
    }(),
    getDesignSchemes: function () {
      var _getDesignSchemes2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var params, response, dataList;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                params = {};
                if (this.contractId) params.contractId = this.contractId;
                _context5.next = 5;
                return (0, _order.getDesignSchemes)(params);

              case 5:
                response = _context5.sent;

                if (response) {
                  dataList = Array.isArray(response) ? response : response.data || [];
                  this.coolHomePlanList = dataList.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      id: item.rowId,
                      rowId: item.rowId,
                      designScheme: item.designScheme,
                      name: item.schemeName,
                      contactPerson: item.createUserName,
                      createTime: item.createTime,
                      designSchemeAudits: (item.designSchemeAudits || []).map(function (audit) {
                        var specialApplication = [];

                        if (audit.specialApplyName) {
                          var specialApplyNames = _this5.parseSpecialApply(audit.specialApplyName);

                          if (Array.isArray(specialApplyNames)) {
                            specialApplication = specialApplyNames.map(function (id) {
                              var apply = _this5.specialApplyOptions.find(function (opt) {
                                return opt.id === parseInt(id);
                              });

                              return apply ? apply.title : id;
                            });
                          }
                        }

                        return _objectSpread(_objectSpread({}, audit), {}, {
                          parentId: item.rowId,
                          _checked: false,
                          specialApplication: specialApplication,
                          originalOrder: audit.originalOrderNumber || ''
                        });
                      }),
                      _checked: false
                    });
                  });
                }

                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                console.error('查询设计方案失败:', _context5.t0);
                this.$message.error('查询设计方案失败');

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function getDesignSchemes() {
        return _getDesignSchemes2.apply(this, arguments);
      }

      return getDesignSchemes;
    }(),
    getSpecialApplyList: function () {
      var _getSpecialApplyList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                params = {};
                if (this.contractId) params.contractId = this.contractId;
                _context6.next = 5;
                return (0, _contract.getContractSpecialApplyList)(params);

              case 5:
                response = _context6.sent;

                if (response && response.code === 200) {
                  this.specialApplyOptions = response.data.map(function (item) {
                    return {
                      id: item.rowId,
                      title: item.title
                    };
                  });
                }

                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);
                console.error('获取特殊申请列表失败:', _context6.t0);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 9]]);
      }));

      function getSpecialApplyList() {
        return _getSpecialApplyList.apply(this, arguments);
      }

      return getSpecialApplyList;
    }(),
    getOriginalOrderList: function () {
      var _getOriginalOrderList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var contractNumber, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                // 优先使用原合同号（源合同号）加载原单号，无源合同号时回退到当前合同号
                contractNumber = this.sourceContractNo || this.contractNo;

                if (contractNumber) {
                  _context7.next = 5;
                  break;
                }

                this.originalOrderOptions = [];
                return _context7.abrupt("return");

              case 5:
                _context7.next = 7;
                return (0, _order.getOriginalOrder)({
                  contractNumber: contractNumber
                });

              case 7:
                response = _context7.sent;

                if (response && response.code === 200 && response.data) {
                  this.originalOrderOptions = (response.data || []).map(function (item) {
                    return {
                      productionOrder: item.productionOrder,
                      auditName: item.auditName
                    };
                  });
                } else {
                  this.originalOrderOptions = [];
                }

                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](0);
                this.originalOrderOptions = [];

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 11]]);
      }));

      function getOriginalOrderList() {
        return _getOriginalOrderList.apply(this, arguments);
      }

      return getOriginalOrderList;
    }(),
    originalOrderSearch: function originalOrderSearch(query, cb) {
      var list = this.originalOrderOptions.filter(function (item) {
        return !query || item.productionOrder.includes(query) || (item.auditName || '').includes(query);
      }).map(function (item) {
        return _objectSpread({
          value: item.productionOrder + ' - ' + item.auditName
        }, item);
      });
      cb(list);
    },
    handleOriginalOrderChange: function () {
      var _handleOriginalOrderChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (row.rowId) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:
                _context8.next = 5;
                return (0, _order.updateOriginalOrder)({
                  rowId: row.rowId,
                  originalOrderNumber: row.originalOrder || ''
                });

              case 5:
                response = _context8.sent;

                if (response && response.code === 200) {
                  this.$message.success('更新原单号成功');
                } else {
                  this.$message.error('更新原单号失败');
                }

                _context8.next = 13;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                console.error('更新原单号失败:', _context8.t0);
                this.$message.error('更新原单号失败');

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function handleOriginalOrderChange(_x4) {
        return _handleOriginalOrderChange.apply(this, arguments);
      }

      return handleOriginalOrderChange;
    }(),
    handleSpecialApplyChange: function () {
      var _handleSpecialApplyChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(row) {
        var response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                if (!(!row.rowId || !row.specialApplication || row.specialApplication.length === 0)) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                _context9.next = 5;
                return (0, _order.syncApply)({
                  title: row.specialApplication,
                  id: row.rowId
                });

              case 5:
                response = _context9.sent;

                if (response && (response.code === 200 || response.data && response.data.code === 200)) {
                  this.$message.success('关联特殊申请成功');
                } else {
                  this.$message.error('关联特殊申请失败');
                }

                _context9.next = 13;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);
                console.error('关联特殊申请失败:', _context9.t0);
                this.$message.error('关联特殊申请失败');

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function handleSpecialApplyChange(_x5) {
        return _handleSpecialApplyChange.apply(this, arguments);
      }

      return handleSpecialApplyChange;
    }(),
    openCoolHomeDialog: function () {
      var _openCoolHomeDialog = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response, kuJiaLeFrameUrl, coolHomeDesignUrlTemplate, coolHomeDesignUrl;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this.contractId) {
                  _context10.next = 3;
                  break;
                }

                this.$message.error('请先选择合同');
                return _context10.abrupt("return");

              case 3:
                _context10.prev = 3;
                _context10.next = 6;
                return (0, _order.associationKuJiaLe)({
                  contractId: this.contractId
                });

              case 6:
                response = _context10.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl;
                  if (typeof kuJiaLeFrameUrl === 'string') kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  coolHomeDesignUrlTemplate = this.$store.state.api.coolHomeDesignUrl;
                  coolHomeDesignUrl = coolHomeDesignUrlTemplate.replace('{kuJiaLeFrameUrl}', kuJiaLeFrameUrl).replace('{contractId}', this.contractId).replace('{userName}', response.data.userName || 'admin');
                  window.open(coolHomeDesignUrl, '_blank');
                } else {
                  this.$message.error('获取酷家乐地址失败,酷家乐账号异常，请联系管理员');
                }

                _context10.next = 13;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](3);
                this.$message.error('调用关联酷家乐方案接口失败,连接酷家乐系统异常，请联系管理员');

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 10]]);
      }));

      function openCoolHomeDialog() {
        return _openCoolHomeDialog.apply(this, arguments);
      }

      return openCoolHomeDialog;
    }(),
    handleCoolHomeDialogClose: function handleCoolHomeDialogClose() {
      this.getDesignSchemes();
    },
    handleCoolHomeClose: function handleCoolHomeClose() {
      var _this6 = this;

      setTimeout(function () {
        _this6.coolHomeDialogVisible = false;
      }, 100);
    },
    handleExpandChange: function handleExpandChange(row, expandedRows) {
      var _this7 = this;

      this.expandedRows = expandedRows;
      this.isAllExpanded = expandedRows.length === this.coolHomePlanList.length;

      if (expandedRows.includes(row.rowId)) {
        this.$nextTick(function () {
          _this7.$setCheckedAudits(row);
        });
      }
    },
    $setCheckedAudits: function () {
      var _$setCheckedAudits = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(schemeRow) {
        var _this8 = this;

        var retryCount,
            tableRef,
            selectedAuditIds,
            _args11 = arguments;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                retryCount = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : 0;

                if (!(retryCount > 10)) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                tableRef = this.$refs['auditTable_' + schemeRow.rowId];

                if (tableRef) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 7;
                return this.$nextTick();

              case 7:
                return _context11.abrupt("return", this.$setCheckedAudits(schemeRow, retryCount + 1));

              case 8:
                selectedAuditIds = this.auditSelections[schemeRow.rowId] || [];

                if (selectedAuditIds.length > 0) {
                  schemeRow.designSchemeAudits.forEach(function (audit) {
                    if (selectedAuditIds.includes(audit.rowId) && _this8.isSelectable(audit)) {
                      tableRef.toggleRowSelection(audit, true);
                    }
                  });
                }

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function $setCheckedAudits(_x6) {
        return _$setCheckedAudits.apply(this, arguments);
      }

      return $setCheckedAudits;
    }(),
    handleRowClick: function handleRowClick(row) {
      if (this.expandedRows.includes(row.rowId)) {
        this.expandedRows = this.expandedRows.filter(function (id) {
          return id !== row.rowId;
        });
      } else {
        this.expandedRows.push(row.rowId);
      }
    },
    handleAuditRowClick: function handleAuditRowClick(row, column) {
      if (column && column.type === 'expand') return;
      var tableRef = this.$refs['auditTable_' + row.parentId];
      if (tableRef) tableRef.toggleRowExpansion(row);
    },
    handleAuditCheckChange: function handleAuditCheckChange(checked, auditRow, schemeRow) {
      if (!this.auditSelections[schemeRow.rowId]) this.auditSelections[schemeRow.rowId] = [];

      if (checked) {
        if (!this.auditSelections[schemeRow.rowId].includes(auditRow.rowId)) this.auditSelections[schemeRow.rowId].push(auditRow.rowId);
      } else {
        var index = this.auditSelections[schemeRow.rowId].indexOf(auditRow.rowId);
        if (index > -1) this.auditSelections[schemeRow.rowId].splice(index, 1);
      }

      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    handleCreateOrderFromExpand: function handleCreateOrderFromExpand(auditRow, schemeRow) {
      this.handleCreateOrder(auditRow);
    },
    handleCreateOrder: function () {
      var _handleCreateOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(row) {
        var _this9 = this;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (row.rowId) {
                  _context13.next = 3;
                  break;
                }

                this.$message.error('缺少提审单ID');
                return _context13.abrupt("return");

              case 3:
                this.$confirm('确定要创建订单吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                  var response, isSuccess;
                  return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _this9.orderLoading = true;
                          _context12.prev = 1;
                          _context12.next = 4;
                          return (0, _order.createMes)({
                            rowId: row.rowId
                          });

                        case 4:
                          response = _context12.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context12.next = 17;
                            break;
                          }

                          _this9.$message.success('创建订单成功');

                          _context12.prev = 8;
                          _context12.next = 11;
                          return _this9.getDesignSchemes();

                        case 11:
                          _context12.next = 15;
                          break;

                        case 13:
                          _context12.prev = 13;
                          _context12.t0 = _context12["catch"](8);

                        case 15:
                          _context12.next = 18;
                          break;

                        case 17:
                          _this9.$message.error(response && response.msg || response && response.data && response.data.msg || '创建订单失败');

                        case 18:
                          _context12.next = 23;
                          break;

                        case 20:
                          _context12.prev = 20;
                          _context12.t1 = _context12["catch"](1);

                          _this9.$message.error(_context12.t1.message || '调用创建订单接口失败');

                        case 23:
                          _context12.prev = 23;
                          _this9.orderLoading = false;
                          return _context12.finish(23);

                        case 26:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12, null, [[1, 20, 23, 26], [8, 13]]);
                }))).catch(function () {});

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function handleCreateOrder(_x7) {
        return _handleCreateOrder.apply(this, arguments);
      }

      return handleCreateOrder;
    }(),
    isSelectable: function isSelectable(row) {
      return row.productionStatus === '未提交' || row.productionStatus === '退回';
    },
    handleDeleteScheme: function handleDeleteScheme(row) {
      var _this10 = this;

      this.$confirm('确定要删除该设计方案吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return (0, _order.delDesignScheme)([row.rowId]);

              case 3:
                response = _context14.sent;

                if (response && response.code === 200) {
                  _this10.$message.success('删除方案成功');

                  _this10.getDesignSchemes();
                } else {
                  _this10.$message.error(response.msg || '删除方案失败');
                }

                _context14.next = 10;
                break;

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14["catch"](0);

                _this10.$message.error('删除方案失败，请重试');

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[0, 7]]);
      }))).catch(function () {});
    },
    handleUnbindScheme: function handleUnbindScheme(row) {
      var _this11 = this;

      this.$confirm('确定要取消关联该设计方案吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return (0, _order.removeBindKuJiaLeCustomerDesginId)({
                  rowId: row.rowId
                });

              case 3:
                response = _context15.sent;

                if (response && response.code === 200) {
                  _this11.$message.success('取消关联成功');

                  _this11.getDesignSchemes();
                } else {
                  _this11.$message.error(response.msg || '取消关联失败');
                }

                _context15.next = 10;
                break;

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);

                _this11.$message.error('取消关联失败，请重试');

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[0, 7]]);
      }))).catch(function () {});
    },
    handleBatchCreateOrder: function () {
      var _handleBatchCreateOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var _this12 = this;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(this.selectedAuditIds.length === 0)) {
                  _context17.next = 3;
                  break;
                }

                this.$message.error('请至少选择一个提审单');
                return _context17.abrupt("return");

              case 3:
                this.$confirm("\u786E\u5B9A\u8981\u4E3A\u9009\u4E2D\u7684".concat(this.selectedAuditIds.length, "\u4E2A\u63D0\u5BA1\u5355\u521B\u5EFA\u8BA2\u5355\u5417\uFF1F"), '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                  var response, isSuccess;
                  return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _this12.orderLoading = true;
                          _context16.prev = 1;
                          _context16.next = 4;
                          return (0, _order.batchCreateMes)(_this12.selectedAuditIds);

                        case 4:
                          response = _context16.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context16.next = 21;
                            break;
                          }

                          _this12.$message.success('批量创建订单成功');

                          _context16.prev = 8;
                          _context16.next = 11;
                          return _this12.getDesignSchemes();

                        case 11:
                          _this12.selectedAuditIds = [];
                          _this12.auditSelections = {};
                          _context16.next = 19;
                          break;

                        case 15:
                          _context16.prev = 15;
                          _context16.t0 = _context16["catch"](8);
                          _this12.selectedAuditIds = [];
                          _this12.auditSelections = {};

                        case 19:
                          _context16.next = 22;
                          break;

                        case 21:
                          _this12.$message.error(response && response.msg || response && response.data && response.data.msg || '批量创建订单失败');

                        case 22:
                          _context16.next = 27;
                          break;

                        case 24:
                          _context16.prev = 24;
                          _context16.t1 = _context16["catch"](1);

                          _this12.$message.error(_context16.t1.message || '调用批量创建订单接口失败');

                        case 27:
                          _context16.prev = 27;
                          _this12.orderLoading = false;
                          return _context16.finish(27);

                        case 30:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16, null, [[1, 24, 27, 30], [8, 15]]);
                }))).catch(function () {});

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleBatchCreateOrder() {
        return _handleBatchCreateOrder.apply(this, arguments);
      }

      return handleBatchCreateOrder;
    }(),
    handleBatchTryInstall: function () {
      var _handleBatchTryInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(isTryInstall) {
        var _this13 = this;

        var canUpdate, actionText;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                canUpdate = isTryInstall ? this.canBatchSetTryInstall : this.canBatchCancelTryInstall;

                if (canUpdate) {
                  _context19.next = 4;
                  break;
                }

                this.$message.warning(isTryInstall ? '仅未提交且当前为正常订单的销售单可以试装' : '仅未提交且当前为试装的销售单可以取消试装');
                return _context19.abrupt("return");

              case 4:
                actionText = isTryInstall ? '设置为试装' : '取消试装';
                this.$confirm("\u786E\u5B9A\u5C06\u9009\u4E2D\u7684".concat(this.selectedAuditIds.length, "\u4E2A\u8BA2\u5355").concat(actionText, "\u5417\uFF1F"), '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                  var response, isSuccess;
                  return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          _this13.orderLoading = true;
                          _context18.prev = 1;
                          _context18.next = 4;
                          return (0, _order.batchUpdateTryInstall)({
                            ids: _this13.selectedAuditIds,
                            isTryInstall: isTryInstall
                          });

                        case 4:
                          response = _context18.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context18.next = 14;
                            break;
                          }

                          _this13.$message.success("\u6279\u91CF".concat(actionText, "\u6210\u529F"));

                          _context18.next = 10;
                          return _this13.getDesignSchemes();

                        case 10:
                          _this13.selectedAuditIds = [];
                          _this13.auditSelections = {};
                          _context18.next = 15;
                          break;

                        case 14:
                          _this13.$message.error(response && response.msg || response && response.data && response.data.msg || "\u6279\u91CF".concat(actionText, "\u5931\u8D25"));

                        case 15:
                          _context18.next = 20;
                          break;

                        case 17:
                          _context18.prev = 17;
                          _context18.t0 = _context18["catch"](1);

                          _this13.$message.error(_context18.t0.message || "\u8C03\u7528\u6279\u91CF".concat(actionText, "\u63A5\u53E3\u5931\u8D25"));

                        case 20:
                          _context18.prev = 20;
                          _this13.orderLoading = false;
                          return _context18.finish(20);

                        case 23:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee18, null, [[1, 17, 20, 23]]);
                }))).catch(function () {});

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function handleBatchTryInstall(_x8) {
        return _handleBatchTryInstall.apply(this, arguments);
      }

      return handleBatchTryInstall;
    }()
  }
};
exports.default = _default;